import api from './api';

export const userService = {
    /**
     * Get current user's profile
     */
    async getProfile() {
        const response = await api.get('/user/profile');
        return response.data;
    },

    /**
     * Create a new user profile
     */
    async createProfile(profileData) {
        const response = await api.post('/user/profile', profileData);
        return response.data;
    },

    /**
     * Update user profile
     */
    async updateProfile(profileData) {
        const response = await api.put('/user/profile', profileData);
        return response.data;
    },

    /**
     * Get user by ID (admin function)
     */
    async getUserById(userId) {
        const response = await api.get(`/user/${userId}`);
        return response.data;
    },

    /**
     * Get all users (admin function)
     */
    async getAllUsers(params = {}) {
        const response = await api.get('/user', { params });
        return response.data;
    },

    /**
     * Update a user by ID (admin function)
     * Allows updating name, studentId, department, phone, isActive, userType.
     */
    async updateUser(userId, updates) {
        const response = await api.put(`/user/${userId}`, updates);
        return response.data;
    },

    /**
     * Update a user's roles (admin function)
     * @param {string} userId
     * @param {string[]} roles - Full roles array to set
     */
    async updateUserRoles(userId, roles) {
        const response = await api.put(`/user/${userId}/roles`, { roles });
        return response.data;
    },
};

export default userService;
